// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.etd {
  --etd-ink: #1f2933;
  --etd-muted: #6b7280;
  --etd-line: #e5e7eb;
  --etd-soft: #f3f5f7;
  --etd-surface: #ffffff;
  --etd-primary: #1976d2;
  --etd-primary-dark: #0d47a1;
  --etd-selected: #e8f1fb;
  --etd-danger: #c62828;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 72px);
  min-width: 0;
  color: var(--etd-ink);
  background: var(--etd-soft);
}

.emr-mz-dashboard .emr-mz-main:has(.etd) {
  padding: 0 !important;
  max-width: none;
  display: flex;
  flex-direction: column;
}

/* Materialize (global, and again under .emr-mz-dashboard) hides every native
   select with \`display: none\` and moves every native checkbox off-screen with
   \`position: absolute; opacity: 0\`. Table Designer reads its field metadata
   through those controls, so it has to opt back out of both. */
.emr-mz-dashboard .etd select,
.etd select {
  display: block !important;
  appearance: auto !important;
  -webkit-appearance: auto !important;
}

.emr-mz-dashboard .etd input[type="checkbox"],
.etd input[type="checkbox"] {
  position: static !important;
  left: auto !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  visibility: visible !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  width: 13px !important;
  height: 13px !important;
  margin: 0 !important;
  z-index: auto !important;
  accent-color: var(--etd-primary);
}

.emr-mz-dashboard .etd input[type="checkbox"]:disabled,
.etd input[type="checkbox"]:disabled {
  cursor: default;
}

.etd__chrome {
  display: flex;
  align-items: center;
  gap: 18px;
  min-height: 44px;
  padding: 0 16px;
  background: var(--etd-surface);
  border-bottom: 1px solid var(--etd-line);
}

.etd__product {
  margin: 0;
  font-size: 15px;
  font-weight: 650;
  letter-spacing: -0.02em;
}

.etd__modules {
  display: flex;
  align-items: center;
  gap: 2px;
  flex: 1 1;
}

.etd__module {
  border: 0;
  background: transparent;
  color: var(--etd-muted);
  font-size: 13px;
  font-weight: 500;
  padding: 10px 10px 8px;
  border-bottom: 2px solid transparent;
  cursor: pointer;
}

.etd__module.is-active {
  color: var(--etd-primary);
  border-bottom-color: var(--etd-primary);
  font-weight: 650;
}

.etd__env {
  font-size: 12px;
  color: var(--etd-muted);
  white-space: nowrap;
}

.etd__workspace {
  display: grid;
  grid-template-columns: 232px minmax(0, 1fr);
  flex: 1 1;
  min-height: 0;
}

/* A module with no table list renders no rail, so the single column is the
   workspace. */
.etd__workspace--full {
  grid-template-columns: minmax(0, 1fr);
}

.etd__rail {
  display: flex;
  flex-direction: column;
  background: var(--etd-surface);
  border-right: 1px solid var(--etd-line);
  min-height: 0;
}

.etd__rail-head {
  padding: 14px 14px 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: var(--etd-muted);
}

.etd__rail-nav {
  display: flex;
  flex-direction: column;
  padding: 0 8px 8px;
}

.etd__rail-item {
  display: flex;
  align-items: center;
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 7px 8px;
  border-radius: 6px;
  font-size: 13px;
  color: var(--etd-ink);
  cursor: pointer;
}

.etd__rail-item.is-active {
  background: var(--etd-selected);
  color: var(--etd-primary-dark);
  font-weight: 600;
}

.etd__search {
  margin: 4px 10px 8px;
  width: calc(100% - 20px);
  border: 1px solid var(--etd-line);
  border-radius: 6px;
  padding: 7px 10px;
  font-size: 13px;
  background: #fafbfc;
}

.etd__search:focus {
  outline: none;
  border-color: var(--etd-primary);
  background: #fff;
}

.etd__tables {
  flex: 1 1;
  overflow: auto;
  padding: 0 8px 8px;
  min-height: 0;
}

.etd__table-item {
  display: block;
  width: 100%;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 13px;
  color: var(--etd-ink);
  cursor: pointer;
}

.etd__table-item.is-active {
  background: var(--etd-selected);
  color: var(--etd-primary-dark);
  font-weight: 600;
}

.etd__new-table {
  margin: 8px 10px 12px;
  border: 0;
  border-radius: 6px;
  background: var(--etd-primary);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 10px;
  cursor: pointer;
}

.etd__new-table:hover {
  background: var(--etd-primary-dark);
}

.etd__main {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  padding: 10px 14px 12px;
}

/* The Form Designer's canvas is the workspace, so the shell around it gives up
   the margin a reading-width page would want. */
.etd__main:has(.efd) {
  padding: 10px 12px 12px;
}

.etd__headline {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 6px;
}

.etd__kicker {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--etd-muted);
}

.etd__lede {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--etd-muted);
}

.etd__table-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}

.etd__table-title {
  margin: 2px 0 0;
  font-size: 20px;
  font-weight: 650;
  letter-spacing: -0.02em;
}

.etd__table-copy {
  margin: 2px 0 0;
  font-size: 13px;
  color: var(--etd-muted);
}

.etd__head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.etd__unsaved {
  font-size: 12px;
  font-weight: 650;
  color: #b45309;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 999px;
  padding: 3px 8px;
  white-space: nowrap;
}

.etd__actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.etd__btn {
  border: 1px solid var(--etd-line);
  background: #fff;
  color: var(--etd-ink);
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 550;
  cursor: pointer;
}

.etd__btn--primary {
  background: var(--etd-primary);
  border-color: var(--etd-primary);
  color: #fff;
}

.etd__btn--ghost {
  background: transparent;
}

.etd__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.etd__views {
  display: flex;
  gap: 0;
}

.etd__view {
  border: 1px solid var(--etd-line);
  background: #fff;
  padding: 5px 10px;
  font-size: 12px;
  cursor: pointer;
}

.etd__view:first-child {
  border-radius: 6px 0 0 6px;
}

.etd__view:last-child {
  border-radius: 0 6px 6px 0;
  margin-left: -1px;
}

.etd__view.is-active {
  background: var(--etd-selected);
  color: var(--etd-primary-dark);
  border-color: #bbdefb;
  font-weight: 650;
  z-index: 1;
}

.etd__design {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 268px;
  gap: 10px;
  min-height: 0;
  flex: 1 1;
}

.etd__validation {
  margin: 0 0 8px;
  padding: 7px 10px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #991b1b;
  border-radius: 6px;
  font-size: 12px;
}

.etd__validation p {
  margin: 0 0 2px;
}

.etd__validation p:last-child {
  margin-bottom: 0;
}

.etd__grid-wrap {
  background: #fff;
  border: 1px solid var(--etd-line);
  border-radius: 8px;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.etd__grid-tools {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-bottom: 1px solid var(--etd-line);
  background: #fafbfc;
}

.etd__grid-tools .etd__search {
  margin: 0;
  width: 180px;
  padding: 4px 8px;
  font-size: 12px;
}

.etd__grid-scroll {
  overflow: auto;
  flex: 1 1;
  min-height: 0;
}

.etd__grid {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  table-layout: fixed;
}

/*
  Materialize is prefixed to \`.emr-mz-dashboard\` and injected after page CSS.
  That makes \`.emr-mz-dashboard td, th { padding: 15px 5px }\` tie or beat
  \`.etd__grid td\`, so a 22px height declaration never becomes the row.
  Inputs lose the same way: \`input[type=text]:not(.browser-default)\` is
  3rem + 8px margin + content-box. Out-specify those two rules here.
*/
.emr-mz-dashboard table.etd__grid th,
.emr-mz-dashboard table.etd__grid td,
.etd__grid th,
.etd__grid td {
  border-bottom: 1px solid #eef1f4;
  padding: 4px 6px;
  text-align: left;
  vertical-align: middle;
  height: 36px;
  line-height: 20px;
  box-sizing: border-box;
}

.emr-mz-dashboard table.etd__grid th,
.etd__grid th {
  font-size: 11px;
  font-weight: 650;
  color: var(--etd-muted);
  background: #f8fafc;
  position: sticky;
  top: 0;
  z-index: 1;
  height: 32px;
  border-bottom-color: var(--etd-line);
}

.etd__grid tr.is-selected td {
  background: var(--etd-selected);
}

.etd__grid tbody tr:hover td {
  background: #f6f9ff;
}

.etd__grid tr.is-selected:hover td {
  background: var(--etd-selected);
}

.etd__col-index {
  width: 32px;
  text-align: center;
  color: var(--etd-muted);
}

.etd__col-name {
  width: 22%;
}

.etd__col-type {
  width: 16%;
}

.etd__col-flag {
  width: 58px;
  text-align: center;
  padding-left: 2px;
  padding-right: 2px;
}

.emr-mz-dashboard .etd__grid input[type="text"]:not(.browser-default),
.emr-mz-dashboard .etd__grid input[type="text"],
.emr-mz-dashboard .etd__grid select,
.etd__grid input[type="text"],
.etd__grid select {
  box-sizing: border-box !important;
  width: 100%;
  height: 28px !important;
  min-height: 0 !important;
  max-height: 28px !important;
  margin: 0 !important;
  border: 1px solid transparent;
  background: transparent;
  font-size: 12px;
  line-height: 20px !important;
  padding: 0 4px !important;
}

.emr-mz-dashboard .etd__grid input[type="text"]:focus,
.emr-mz-dashboard .etd__grid select:focus,
.etd__grid input[type="text"]:focus,
.etd__grid select:focus {
  outline: none;
  border-color: var(--etd-primary);
  background: #fff;
  border-radius: 4px;
}

.etd__cell-text {
  display: block;
  font-size: 12px;
  line-height: 20px;
  height: 28px;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.etd__check {
  text-align: center;
}

.etd__check input[type="checkbox"] {
  display: inline-block;
}

.etd__flag {
  display: block;
  font-size: 12px;
  line-height: 28px;
  height: 28px;
  color: var(--etd-primary);
  text-align: center;
}

.etd__props {
  background: #fff;
  border: 1px solid var(--etd-line);
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 0;
  min-height: 0;
  overflow: auto;
}

.etd__props h3 {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 650;
}

.etd__prop-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.etd__prop-tab {
  border: 0;
  background: transparent;
  padding: 0 0 4px;
  font-size: 12px;
  color: var(--etd-muted);
  border-bottom: 2px solid transparent;
  cursor: pointer;
}

.etd__prop-tab.is-active {
  color: var(--etd-primary);
  border-bottom-color: var(--etd-primary);
  font-weight: 650;
}

.etd__field {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 8px;
}

.etd__prop-value {
  font-size: 13px;
  padding: 2px 0;
  word-break: break-word;
}

.etd__field label {
  font-size: 12px;
  color: var(--etd-muted);
}

.etd__field input,
.etd__field select,
.etd__field textarea {
  border: 1px solid var(--etd-line);
  border-radius: 6px;
  padding: 5px 8px;
  font-size: 12px;
}

.etd__field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.etd__toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  margin-bottom: 6px;
}

.etd__datasheet {
  background: #fff;
  border: 1px solid var(--etd-line);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1;
}

.etd__sheet-tools {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border-bottom: 1px solid var(--etd-line);
}

.etd__sheet-tools input[type="search"] {
  flex: 1 1;
  border: 1px solid var(--etd-line);
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 13px;
}

.etd__sheet-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.etd__sheet-table th,
.etd__sheet-table td {
  border-bottom: 1px solid var(--etd-line);
  padding: 7px 10px;
  text-align: left;
  white-space: nowrap;
}

.etd__sheet-table th {
  background: #fafbfc;
  font-size: 12px;
  color: var(--etd-muted);
  font-weight: 650;
  position: sticky;
  top: 0;
  z-index: 1;
}

/* A header that says more than its label does says it on hover. */
.etd__sheet-table th[title] {
  cursor: help;
}

/* A key column reads as the row it points at, so it is named, not shouted. */
.etd__sheet-table th[data-lookup="true"] {
  color: var(--etd-primary);
}

.etd__sheet-table td.is-muted {
  color: var(--etd-muted);
}

.etd__sheet-table th.is-right,
.etd__sheet-table td.is-right {
  text-align: right;
}

.etd__sheet-table tbody tr:hover td {
  background: #f6f9ff;
}

.etd__columns-group {
  margin: 10px 0 6px;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--etd-muted);
  border-top: 1px solid var(--etd-line);
  padding-top: 8px;
}

.etd__sheet-scroll {
  overflow: auto;
  flex: 1 1;
}

.etd__columns {
  position: relative;
}

.etd__columns-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 4px);
  z-index: 4;
  background: #fff;
  border: 1px solid var(--etd-line);
  border-radius: 8px;
  padding: 8px;
  min-width: 220px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.etd__placeholder {
  background: #fff;
  border: 1px solid var(--etd-line);
  border-radius: 8px;
  padding: 28px;
  color: var(--etd-muted);
}

.etd__form {
  background: #fff;
  border: 1px solid var(--etd-line);
  border-radius: 8px;
  padding: 18px;
  max-width: 640px;
}

.etd__form h2 {
  margin: 0 0 12px;
  font-size: 20px;
}

.etd__fields {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.etd__chip {
  background: var(--etd-selected);
  color: var(--etd-primary-dark);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
}

.etd__dialog {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
}

.etd__dialog-card {
  width: min(420px, calc(100vw - 32px));
  background: #fff;
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);
}

.etd__dialog-card h2 {
  margin: 0 0 12px;
  font-size: 18px;
}

.etd__sql {
  margin-top: 8px;
  padding: 8px;
  background: #f8fafc;
  border: 1px solid var(--etd-line);
  border-radius: 6px;
  font-size: 11px;
  white-space: pre-wrap;
  max-height: 180px;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-table-designer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;+DAG+D;AAC/D;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,uCAAuC;EACvC,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAO;EACP,aAAa;AACf;;AAEA;eACe;AACf;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uCAAuC;EACvC,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,iCAAiC;EACjC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,uBAAuB;AACzB;;AAEA;gDACgD;AAChD;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,MAAM;AACR;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,aAAa;EACb,SAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;;;CAMC;AACD;;;;EAIE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;EAKE,iCAAiC;EACjC,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;;;EAIE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;;;EAGE,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,kEAAkE;AAClE;EACE,YAAY;AACd;;AAEA,6EAA6E;AAC7E;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".etd {\n  --etd-ink: #1f2933;\n  --etd-muted: #6b7280;\n  --etd-line: #e5e7eb;\n  --etd-soft: #f3f5f7;\n  --etd-surface: #ffffff;\n  --etd-primary: #1976d2;\n  --etd-primary-dark: #0d47a1;\n  --etd-selected: #e8f1fb;\n  --etd-danger: #c62828;\n  display: flex;\n  flex-direction: column;\n  min-height: calc(100vh - 72px);\n  min-width: 0;\n  color: var(--etd-ink);\n  background: var(--etd-soft);\n}\n\n.emr-mz-dashboard .emr-mz-main:has(.etd) {\n  padding: 0 !important;\n  max-width: none;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Materialize (global, and again under .emr-mz-dashboard) hides every native\n   select with `display: none` and moves every native checkbox off-screen with\n   `position: absolute; opacity: 0`. Table Designer reads its field metadata\n   through those controls, so it has to opt back out of both. */\n.emr-mz-dashboard .etd select,\n.etd select {\n  display: block !important;\n  appearance: auto !important;\n  -webkit-appearance: auto !important;\n}\n\n.emr-mz-dashboard .etd input[type=\"checkbox\"],\n.etd input[type=\"checkbox\"] {\n  position: static !important;\n  left: auto !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  visibility: visible !important;\n  appearance: auto !important;\n  -webkit-appearance: checkbox !important;\n  width: 13px !important;\n  height: 13px !important;\n  margin: 0 !important;\n  z-index: auto !important;\n  accent-color: var(--etd-primary);\n}\n\n.emr-mz-dashboard .etd input[type=\"checkbox\"]:disabled,\n.etd input[type=\"checkbox\"]:disabled {\n  cursor: default;\n}\n\n.etd__chrome {\n  display: flex;\n  align-items: center;\n  gap: 18px;\n  min-height: 44px;\n  padding: 0 16px;\n  background: var(--etd-surface);\n  border-bottom: 1px solid var(--etd-line);\n}\n\n.etd__product {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 650;\n  letter-spacing: -0.02em;\n}\n\n.etd__modules {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  flex: 1;\n}\n\n.etd__module {\n  border: 0;\n  background: transparent;\n  color: var(--etd-muted);\n  font-size: 13px;\n  font-weight: 500;\n  padding: 10px 10px 8px;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n}\n\n.etd__module.is-active {\n  color: var(--etd-primary);\n  border-bottom-color: var(--etd-primary);\n  font-weight: 650;\n}\n\n.etd__env {\n  font-size: 12px;\n  color: var(--etd-muted);\n  white-space: nowrap;\n}\n\n.etd__workspace {\n  display: grid;\n  grid-template-columns: 232px minmax(0, 1fr);\n  flex: 1;\n  min-height: 0;\n}\n\n/* A module with no table list renders no rail, so the single column is the\n   workspace. */\n.etd__workspace--full {\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.etd__rail {\n  display: flex;\n  flex-direction: column;\n  background: var(--etd-surface);\n  border-right: 1px solid var(--etd-line);\n  min-height: 0;\n}\n\n.etd__rail-head {\n  padding: 14px 14px 8px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: var(--etd-muted);\n}\n\n.etd__rail-nav {\n  display: flex;\n  flex-direction: column;\n  padding: 0 8px 8px;\n}\n\n.etd__rail-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  padding: 7px 8px;\n  border-radius: 6px;\n  font-size: 13px;\n  color: var(--etd-ink);\n  cursor: pointer;\n}\n\n.etd__rail-item.is-active {\n  background: var(--etd-selected);\n  color: var(--etd-primary-dark);\n  font-weight: 600;\n}\n\n.etd__search {\n  margin: 4px 10px 8px;\n  width: calc(100% - 20px);\n  border: 1px solid var(--etd-line);\n  border-radius: 6px;\n  padding: 7px 10px;\n  font-size: 13px;\n  background: #fafbfc;\n}\n\n.etd__search:focus {\n  outline: none;\n  border-color: var(--etd-primary);\n  background: #fff;\n}\n\n.etd__tables {\n  flex: 1;\n  overflow: auto;\n  padding: 0 8px 8px;\n  min-height: 0;\n}\n\n.etd__table-item {\n  display: block;\n  width: 100%;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  padding: 6px 8px;\n  border-radius: 6px;\n  font-size: 13px;\n  color: var(--etd-ink);\n  cursor: pointer;\n}\n\n.etd__table-item.is-active {\n  background: var(--etd-selected);\n  color: var(--etd-primary-dark);\n  font-weight: 600;\n}\n\n.etd__new-table {\n  margin: 8px 10px 12px;\n  border: 0;\n  border-radius: 6px;\n  background: var(--etd-primary);\n  color: #fff;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 8px 10px;\n  cursor: pointer;\n}\n\n.etd__new-table:hover {\n  background: var(--etd-primary-dark);\n}\n\n.etd__main {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 0;\n  padding: 10px 14px 12px;\n}\n\n/* The Form Designer's canvas is the workspace, so the shell around it gives up\n   the margin a reading-width page would want. */\n.etd__main:has(.efd) {\n  padding: 10px 12px 12px;\n}\n\n.etd__headline {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 6px;\n}\n\n.etd__kicker {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--etd-muted);\n}\n\n.etd__lede {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: var(--etd-muted);\n}\n\n.etd__table-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.etd__table-title {\n  margin: 2px 0 0;\n  font-size: 20px;\n  font-weight: 650;\n  letter-spacing: -0.02em;\n}\n\n.etd__table-copy {\n  margin: 2px 0 0;\n  font-size: 13px;\n  color: var(--etd-muted);\n}\n\n.etd__head-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.etd__unsaved {\n  font-size: 12px;\n  font-weight: 650;\n  color: #b45309;\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  border-radius: 999px;\n  padding: 3px 8px;\n  white-space: nowrap;\n}\n\n.etd__actions {\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.etd__btn {\n  border: 1px solid var(--etd-line);\n  background: #fff;\n  color: var(--etd-ink);\n  border-radius: 6px;\n  padding: 5px 10px;\n  font-size: 12px;\n  font-weight: 550;\n  cursor: pointer;\n}\n\n.etd__btn--primary {\n  background: var(--etd-primary);\n  border-color: var(--etd-primary);\n  color: #fff;\n}\n\n.etd__btn--ghost {\n  background: transparent;\n}\n\n.etd__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.etd__views {\n  display: flex;\n  gap: 0;\n}\n\n.etd__view {\n  border: 1px solid var(--etd-line);\n  background: #fff;\n  padding: 5px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.etd__view:first-child {\n  border-radius: 6px 0 0 6px;\n}\n\n.etd__view:last-child {\n  border-radius: 0 6px 6px 0;\n  margin-left: -1px;\n}\n\n.etd__view.is-active {\n  background: var(--etd-selected);\n  color: var(--etd-primary-dark);\n  border-color: #bbdefb;\n  font-weight: 650;\n  z-index: 1;\n}\n\n.etd__design {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 268px;\n  gap: 10px;\n  min-height: 0;\n  flex: 1;\n}\n\n.etd__validation {\n  margin: 0 0 8px;\n  padding: 7px 10px;\n  border: 1px solid #fecaca;\n  background: #fef2f2;\n  color: #991b1b;\n  border-radius: 6px;\n  font-size: 12px;\n}\n\n.etd__validation p {\n  margin: 0 0 2px;\n}\n\n.etd__validation p:last-child {\n  margin-bottom: 0;\n}\n\n.etd__grid-wrap {\n  background: #fff;\n  border: 1px solid var(--etd-line);\n  border-radius: 8px;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.etd__grid-tools {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--etd-line);\n  background: #fafbfc;\n}\n\n.etd__grid-tools .etd__search {\n  margin: 0;\n  width: 180px;\n  padding: 4px 8px;\n  font-size: 12px;\n}\n\n.etd__grid-scroll {\n  overflow: auto;\n  flex: 1;\n  min-height: 0;\n}\n\n.etd__grid {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n  table-layout: fixed;\n}\n\n/*\n  Materialize is prefixed to `.emr-mz-dashboard` and injected after page CSS.\n  That makes `.emr-mz-dashboard td, th { padding: 15px 5px }` tie or beat\n  `.etd__grid td`, so a 22px height declaration never becomes the row.\n  Inputs lose the same way: `input[type=text]:not(.browser-default)` is\n  3rem + 8px margin + content-box. Out-specify those two rules here.\n*/\n.emr-mz-dashboard table.etd__grid th,\n.emr-mz-dashboard table.etd__grid td,\n.etd__grid th,\n.etd__grid td {\n  border-bottom: 1px solid #eef1f4;\n  padding: 4px 6px;\n  text-align: left;\n  vertical-align: middle;\n  height: 36px;\n  line-height: 20px;\n  box-sizing: border-box;\n}\n\n.emr-mz-dashboard table.etd__grid th,\n.etd__grid th {\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--etd-muted);\n  background: #f8fafc;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  height: 32px;\n  border-bottom-color: var(--etd-line);\n}\n\n.etd__grid tr.is-selected td {\n  background: var(--etd-selected);\n}\n\n.etd__grid tbody tr:hover td {\n  background: #f6f9ff;\n}\n\n.etd__grid tr.is-selected:hover td {\n  background: var(--etd-selected);\n}\n\n.etd__col-index {\n  width: 32px;\n  text-align: center;\n  color: var(--etd-muted);\n}\n\n.etd__col-name {\n  width: 22%;\n}\n\n.etd__col-type {\n  width: 16%;\n}\n\n.etd__col-flag {\n  width: 58px;\n  text-align: center;\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.emr-mz-dashboard .etd__grid input[type=\"text\"]:not(.browser-default),\n.emr-mz-dashboard .etd__grid input[type=\"text\"],\n.emr-mz-dashboard .etd__grid select,\n.etd__grid input[type=\"text\"],\n.etd__grid select {\n  box-sizing: border-box !important;\n  width: 100%;\n  height: 28px !important;\n  min-height: 0 !important;\n  max-height: 28px !important;\n  margin: 0 !important;\n  border: 1px solid transparent;\n  background: transparent;\n  font-size: 12px;\n  line-height: 20px !important;\n  padding: 0 4px !important;\n}\n\n.emr-mz-dashboard .etd__grid input[type=\"text\"]:focus,\n.emr-mz-dashboard .etd__grid select:focus,\n.etd__grid input[type=\"text\"]:focus,\n.etd__grid select:focus {\n  outline: none;\n  border-color: var(--etd-primary);\n  background: #fff;\n  border-radius: 4px;\n}\n\n.etd__cell-text {\n  display: block;\n  font-size: 12px;\n  line-height: 20px;\n  height: 28px;\n  padding: 0 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.etd__check {\n  text-align: center;\n}\n\n.etd__check input[type=\"checkbox\"] {\n  display: inline-block;\n}\n\n.etd__flag {\n  display: block;\n  font-size: 12px;\n  line-height: 28px;\n  height: 28px;\n  color: var(--etd-primary);\n  text-align: center;\n}\n\n.etd__props {\n  background: #fff;\n  border: 1px solid var(--etd-line);\n  border-radius: 8px;\n  padding: 10px 12px;\n  min-width: 0;\n  min-height: 0;\n  overflow: auto;\n}\n\n.etd__props h3 {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.etd__prop-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.etd__prop-tab {\n  border: 0;\n  background: transparent;\n  padding: 0 0 4px;\n  font-size: 12px;\n  color: var(--etd-muted);\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n}\n\n.etd__prop-tab.is-active {\n  color: var(--etd-primary);\n  border-bottom-color: var(--etd-primary);\n  font-weight: 650;\n}\n\n.etd__field {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  margin-bottom: 8px;\n}\n\n.etd__prop-value {\n  font-size: 13px;\n  padding: 2px 0;\n  word-break: break-word;\n}\n\n.etd__field label {\n  font-size: 12px;\n  color: var(--etd-muted);\n}\n\n.etd__field input,\n.etd__field select,\n.etd__field textarea {\n  border: 1px solid var(--etd-line);\n  border-radius: 6px;\n  padding: 5px 8px;\n  font-size: 12px;\n}\n\n.etd__field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.etd__toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  margin-bottom: 6px;\n}\n\n.etd__datasheet {\n  background: #fff;\n  border: 1px solid var(--etd-line);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1;\n}\n\n.etd__sheet-tools {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--etd-line);\n}\n\n.etd__sheet-tools input[type=\"search\"] {\n  flex: 1;\n  border: 1px solid var(--etd-line);\n  border-radius: 6px;\n  padding: 6px 8px;\n  font-size: 13px;\n}\n\n.etd__sheet-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.etd__sheet-table th,\n.etd__sheet-table td {\n  border-bottom: 1px solid var(--etd-line);\n  padding: 7px 10px;\n  text-align: left;\n  white-space: nowrap;\n}\n\n.etd__sheet-table th {\n  background: #fafbfc;\n  font-size: 12px;\n  color: var(--etd-muted);\n  font-weight: 650;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n/* A header that says more than its label does says it on hover. */\n.etd__sheet-table th[title] {\n  cursor: help;\n}\n\n/* A key column reads as the row it points at, so it is named, not shouted. */\n.etd__sheet-table th[data-lookup=\"true\"] {\n  color: var(--etd-primary);\n}\n\n.etd__sheet-table td.is-muted {\n  color: var(--etd-muted);\n}\n\n.etd__sheet-table th.is-right,\n.etd__sheet-table td.is-right {\n  text-align: right;\n}\n\n.etd__sheet-table tbody tr:hover td {\n  background: #f6f9ff;\n}\n\n.etd__columns-group {\n  margin: 10px 0 6px;\n  font-size: 11px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--etd-muted);\n  border-top: 1px solid var(--etd-line);\n  padding-top: 8px;\n}\n\n.etd__sheet-scroll {\n  overflow: auto;\n  flex: 1;\n}\n\n.etd__columns {\n  position: relative;\n}\n\n.etd__columns-menu {\n  position: absolute;\n  right: 0;\n  top: calc(100% + 4px);\n  z-index: 4;\n  background: #fff;\n  border: 1px solid var(--etd-line);\n  border-radius: 8px;\n  padding: 8px;\n  min-width: 220px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n.etd__placeholder {\n  background: #fff;\n  border: 1px solid var(--etd-line);\n  border-radius: 8px;\n  padding: 28px;\n  color: var(--etd-muted);\n}\n\n.etd__form {\n  background: #fff;\n  border: 1px solid var(--etd-line);\n  border-radius: 8px;\n  padding: 18px;\n  max-width: 640px;\n}\n\n.etd__form h2 {\n  margin: 0 0 12px;\n  font-size: 20px;\n}\n\n.etd__fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.etd__chip {\n  background: var(--etd-selected);\n  color: var(--etd-primary-dark);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 12px;\n}\n\n.etd__dialog {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.28);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 20;\n}\n\n.etd__dialog-card {\n  width: min(420px, calc(100vw - 32px));\n  background: #fff;\n  border-radius: 10px;\n  padding: 18px;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);\n}\n\n.etd__dialog-card h2 {\n  margin: 0 0 12px;\n  font-size: 18px;\n}\n\n.etd__sql {\n  margin-top: 8px;\n  padding: 8px;\n  background: #f8fafc;\n  border: 1px solid var(--etd-line);\n  border-radius: 6px;\n  font-size: 11px;\n  white-space: pre-wrap;\n  max-height: 180px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
